module.exports = __webpack_public_path__ + "img/logo_jassa.6e0f874d.png";